import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ClienteService } from '../../services/cliente.service';
import { Cliente } from '../../models/cliente';

@Component({
  selector: 'app-cliente-resumen-detalle',
  templateUrl: './cliente-resumen-detalle.component.html',
  styleUrls: ['./cliente-resumen-detalle.component.scss'],
})
export class ClienteResumenDetalleComponent implements OnInit, OnChanges {
  // puede recibir el cliente o el id
  @Input() clienteId: number = null;
  @Input() cliente: Cliente = null;
  @Input() permiteNavegacion: boolean = true;

  // envia errores al padre para que los muestre
  @Output() sendToastMsg: EventEmitter<object> = new EventEmitter<object>();

  constructor(private clienteService: ClienteService) { }

  ngOnInit(): void {
    if (this.cliente === null) {
      this.getCliente();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clienteId'] ) {
      this.getCliente();
    }
  }


  getCliente() {
    this.clienteService.getById(this.clienteId).subscribe(
      (data) => {
        this.cliente = data;
      },
      (error) => {
        var errorMessage = <any>error;
        if (errorMessage != null) {
          this.sendToastMsg.emit({
            mensajeError: true,
            mensaje: error.error.message,
          });
        }
      }
    );
  }
}
